/**
 * DNSMPI / CCPA opt-out helpers for Shopify Customer Privacy API + localStorage.
 */
(function () {
  var STORAGE_KEY = 'tsm_dnsmpi_optout_v1';
  var BOOTSTRAP_SCRIPT_ID = 'dnsmpi-privacy-bootstrap';

  function readStored() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (err) {
      return null;
    }
  }

  function persistOptOut(source) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          optedOut: true,
          at: new Date().toISOString(),
          source: source || 'dnsmpi'
        })
      );
    } catch (err) {
      /* private mode / quota */
    }
  }

  function applyShopifyOptOut(callback) {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
      ) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: false,
            marketing: false,
            preferences: false,
            sale_of_data: false
          },
          callback || function () {}
        );
        return true;
      }
    } catch (err) {
      if (window.console && console.warn) {
        console.warn('Shopify Customer Privacy API not available', err);
      }
    }
    return false;
  }

  function shouldApply(config) {
    config = config || {};
    var stored = readStored();
    if (stored && stored.optedOut) return true;
    if (config.accountOptedOut) return true;
    return false;
  }

  function run(config) {
    config = config || {};
    if (!shouldApply(config)) return;

    if (config.accountOptedOut) {
      persistOptOut('shopify_customer_tag');
    }

    if (applyShopifyOptOut()) return;

    var attempts = 0;
    var maxAttempts = 60;
    var interval = setInterval(function () {
      attempts += 1;
      if (applyShopifyOptOut() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 250);
  }

  function readBootstrapConfig() {
    var script = document.getElementById(BOOTSTRAP_SCRIPT_ID);
    if (!script || !script.hasAttribute('data-dnsmpi-bootstrap')) return null;

    return {
      accountOptedOut: script.getAttribute('data-dnsmpi-account-opted-out') === 'true'
    };
  }

  function initPageBootstrap() {
    var config = readBootstrapConfig();
    if (!config) return;
    run(config);
  }

  window.TSMCustomerPrivacyOptOut = {
    STORAGE_KEY: STORAGE_KEY,
    readStored: readStored,
    persistOptOut: persistOptOut,
    applyShopifyOptOut: applyShopifyOptOut,
    shouldApply: shouldApply,
    run: run
  };

  initPageBootstrap();
})();
